import Main from './Main.svelte';

const app = new Main({
	target: document.getElementById('app'),
	props: {}
});

export default app;